import { RoutedModal } from "../RoutedModal";
import { BellRingIcon } from "../../../assets/svgIcons";
import { BusinessSupplierConsent } from "..";
import messageSound from "../../../assets/sounds/message.mp3";
import { useEffect, useRef } from "react";
import { useWebSocketEventHandler } from "../../../hooks/useWebSocketEvents";

export const BusinessSupplierConsentPrompt = ({ children }) => {
  const { wsEvents, clearWsEvent } = useWebSocketEventHandler();
  const soundRef = useRef(new Audio(messageSound));

  useEffect(() => {
    if (wsEvents?.show_supplier_consent_dialog)
      soundRef.current?.play().catch(() => {});
  }, [wsEvents?.show_supplier_consent_dialog]);

  return (
    <>
      {children}
      <RoutedModal
        isActive={wsEvents?.show_supplier_consent_dialog}
        width={700}
        closeModal={() =>
          clearWsEvent({ eventType: "show_supplier_consent_dialog" })
        }
        headerTitle={
          <span className="d-flex align-items-center">
            Invite Supplier
            <BellRingIcon
              className="ml-3 orange--text"
              style={{ fontSize: "30px" }}
            />
          </span>
        }
        style={{ height: "auto" }}
        closeViaOverlay={false}
      >
        <BusinessSupplierConsent
          closeModal={() =>
            clearWsEvent({ eventType: "show_supplier_consent_dialog" })
          }
        />
      </RoutedModal>
    </>
  );
};
